<template>
  <div class="builder">

    <div v-if="parseInt(this.product.has_inventory) && parseInt(this.product.total_inventory) < 1" class="builder__errors">
      SOLD OUT
    </div>

    <builder-heading :price="priceHtml" :product="product" :title-additions="titleAdditions"></builder-heading>

    <!-- desktop actions, mobile actions are below -->
    <builder-actions
      v-if="hasCookies"
      :initial-query-string="initialQueryString"
      :is-sold-out="parseInt(this.product.has_inventory) && parseInt(this.product.total_inventory) < 1"
      :is-widescreen="true"
      :is-submitting="isSubmitting"
      :share-link="shareLink"
      :download-image-link="downloadImageLink"
      @add-to-cart="submit(true)"
      @add-to-comparison-gallery="submit(false)"
      @clear-options="clearOptions"
      @reset-options-to-initial-query-string="selectOptionsFromQueryString(initialQueryString)"
      ></builder-actions>

    <div class="builder__details-and-steps">

      <div class="builder__details">
        <builder-imagery :product="product" :imagery-layer-srcs="imageryLayerSrcs"></builder-imagery>
        <div class="builder__guide-toggle" v-if="product.guide_photo_src">
          <input id="guide-toggle" class="builder__guide-toggle-input" type="checkbox" v-model="showGuide"> <label for="guide-toggle" class="builder__guide-toggle-label">Guide</label>
        </div>
        <builder-description :product="product" :is-widescreen="true"></builder-description>
      </div>

      <div class="builder__steps">
        <div class="builder__steps-liner">
          <div v-for="(drawer, drawerIndex) in draweredGroupedOptionsWithSelectedValues" :class="drawerClasses(drawerIndex)">

            <div v-if="drawer.drawerOption !== null" class="builder__drawer-header">
              <h2>
                <button type="button" @click="drawerHeaderClickHandler(drawerIndex)">{{ drawer.drawerOption.display_title ? drawer.drawerOption.display_title : drawer.drawerOption.title }}</button>
              </h2>
            </div>

            <div :class="drawerOptionsClasses(drawerIndex)">
              <builder-option
               v-for="option in drawer.options"
               :key="option.id"
               :option="option"
               @input="selectOptionValue"
               :is-expanded="(expandedOptionId == option.id)"
               @expand-option="expandedOptionId = $event"
               @collapse-option="expandedOptionId = null"
              ></builder-option>
            </div>

          </div>
        </div>
      </div>

    </div>

    <!-- mobile actions, desktop actions are above -->
    <builder-actions
      v-if="hasCookies"
      :initial-query-string="initialQueryString"
      :is-sold-out="parseInt(this.product.has_inventory) && parseInt(this.product.total_inventory) < 1"
      :is-widescreen="false"
      :is-submitting="isSubmitting"
      :share-link="shareLink"
      :download-image-link="downloadImageLink"
      @add-to-cart="submit(true)"
      @add-to-comparison-gallery="submit(false)"
      @clear-options="clearOptions"
      @reset-options-to-initial-query-string="selectOptionsFromQueryString(initialQueryString)"
      ></builder-actions>

    <builder-description :product="product" :is-widescreen="false"></builder-description>

  </div>
</template>

<script>
  export default {
    name: 'custom-builder-app',

    components: {
      'builder-heading': require('./components/Heading.vue'),
      'builder-actions': require('./components/Actions.vue'),
      'builder-option': require('./components/Option.vue'),
      'builder-imagery': require('./components/Imagery.vue'),
      'builder-description': require('./components/Description.vue'),
    },

    data() {
      return {
        product: customBuilderAppData.product,
        selectedOptionValues: {}, //key is option id, value is choice id or user-supplied text (depending on option type)
        expandedOptionId: null,
        isSubmitting: false,
        hasCookies: customBuilderAppData.hasCookies,
        initialQueryString: '',
        showGuide: false,
        openDrawerIndex: 0, //open the first drawer on page load
//        priceHtml: '$',
      }
    },

    created() {
      //pre-populate option selections from querystring data...
      this.initialQueryString = window.location.search.substring(1)
      this.selectOptionsFromQueryString(this.initialQueryString)
    },

    watch: {
      selectedOptionValues: {
        handler() {
          window.history.replaceState(null, null, `${window.location.origin}${window.location.pathname}${this.queryString}`)
        },
        deep: true,
      },
    },

    computed: {
      titleAdditions() {
        let additions = []
        //loop through all options' choices,
        // adding titles to the array for all selected choices
        // that are append_title...
        this.product.options.forEach(o => {
          if (o.append_title == 1) {
            const choice = o.choices.filter(c => c.id == this.selectedOptionValues[o.id])
            if (choice.length > 0 && choice[0].title.length > 0) {
              additions.push(choice[0].title)
            }
          }
        })
        return additions
      },

      imageryLayerSrcs() {
        let srcs = []
        let srcs2 = []

        if (this.product.builder_base_overlay_photo_fID) {
          srcs2.push(this.product.builder_base_overlay_photo_src)
        }

        //loop through all options' choices,
        // adding img src's to the array for all selected choices
        // that have a builder overlay image...
        this.product.options.forEach(o => {
          if (o.choices && (o.id in this.selectedOptionValues)) {
            let choice = o.choices.filter(c => c.id == this.selectedOptionValues[o.id])
            if (choice.length && choice[0].custom_builder_overlay_image_fID) {
              srcs.push(choice[0].custom_builder_overlay_image_src)
            }
            if (choice.length && choice[0].custom_builder_overlay_image_2_fID) {
              srcs2.push(choice[0].custom_builder_overlay_image_2_src)
            }
          }
        })
        srcs = srcs.concat(srcs2)

        if (this.showGuide && this.product.guide_photo_src) {
          srcs.push(this.product.guide_photo_src)
        }

        return srcs
      },

      drawerAvailability() { //true if a drawer is available to be opened, otherwise index of drawer that prevents that
        let drawerAvailability = []
        this.draweredGroupedOptionsWithSelectedValues.forEach(function(drawer, drawerIndex) {
          let mayBeOpened = true //be optimistic
          let drawerPreventingIndex = null
          for (let i = 0; mayBeOpened && i < drawerIndex; i++) {
            if (!this.drawerSatisfaction[i]) {
              mayBeOpened = false
              drawerPreventingIndex = i
            }
          }
          drawerAvailability[drawerIndex] = mayBeOpened ? true : drawerPreventingIndex
        }, this)
        return drawerAvailability
      },

      drawerCompletion() {
        let drawerCompletion = []
        this.draweredGroupedOptionsWithSelectedValues.forEach(function(drawer, drawerIndex) {
          let isComplete = true //be optimistic
          drawer.options.forEach(function(option) {
            if (this.validateGroupedOption(option, []) !== true) {
              isComplete = false
            }
          }, this)
          drawerCompletion[drawerIndex] = isComplete
        }, this)
        return drawerCompletion
      },

      drawerSatisfaction() {
        let drawerSatisfaction = []
        this.draweredGroupedOptionsWithSelectedValues.forEach(function(drawer, drawerIndex) {
          let isSatisfied = true //be optimistic
          if (    drawer.drawerOption
               && drawer.drawerOption.is_required
               && (    this.draweredGroupedOptionsAvailableForDrawer(drawerIndex) < 1
                    || !this.drawerCompletion[drawerIndex] ) ) {
            isSatisfied = false
          }
          drawerSatisfaction[drawerIndex] = isSatisfied
        }, this)
        return drawerSatisfaction
      },

      draweredGroupedOptionsWithSelectedValues() {
        let drawers = []
        this.groupedOptionsWithSelectedValues.forEach(o => {
          if (o.display_type === 'drawer') {
            // create a new drawer for the options that will follow
            drawers.push({drawerOption: o, options: []})
          } else {
            if (drawers.length === 0) {
              // un-drawered options may exists before the first drawer
              // create an untitled drawer to hold these
              drawers.push({drawerOption: null, options: []})
            }
            drawers[drawers.length - 1].options.push(o)
          }
        })
        return drawers
      },

      groupedOptionsWithSelectedValues() {
        let options = []

        this.product.options.forEach(o => {
          let selectedValue = (o.id in this.selectedOptionValues) ? this.selectedOptionValues[o.id] : null
          Vue.set(o, 'selected_value', selectedValue)

          if (o.is_embroidery_grouped) {
            //add this to the previous "top-level" option's group
            // (we assume back-end validation ensured [during data entry]
            // that a prior embroidery-type option exists before this grouped option)
            options[options.length - 1].embroidery_grouped_options.push(o)
          } else {
            //add this as a "top-level" option (since it's not grouped under a prior embroidery option)
            Vue.set(o, 'embroidery_grouped_options', [])
            options.push(o)
          }
        })

        return options
      },

      price() {
        return this.product.options.reduce((acc, o) => { // total up price adjustments of selected option choices
          let add = 0
          let selectedValue = (o.id in this.selectedOptionValues) ? this.selectedOptionValues[o.id] : null
          if (selectedValue) {
            add += o.choices.reduce((c_acc, c) => c_acc + (c.id === selectedValue && c.price_adjustment ? parseFloat(c.price_adjustment) : 0), 0)
          }
          return acc + add
        }, parseFloat(this.product.price)) // initial accumulator value is the base product price
      },

      priceHtml() {
        return `$${this.price.toFixed(2)}`
      },

      queryString() {
        let params = {}

        //grab non-empty option selections
        Object.keys(this.selectedOptionValues).forEach(key => {
          if (this.selectedOptionValues[key]) {
            params[key] = this.selectedOptionValues[key]
          }
        })

        return (Object.keys(params).length ? '?' + $.param(params) : '')
      },

      shareLink() {
        return customBuilderAppData.pageUrl + this.queryString
      },

      downloadImageLink() {
        return customBuilderAppData.downloadImageUrl + this.queryString + (this.queryString.length ? '&' : '?') + 'download=true'
      },
    },

    methods: {
      clearOptions() {
        this.selectedOptionValues = {}
        this.openDrawerIndex = 0
      },

      drawerClasses(drawerIndex) {
        let classes = { 'builder__drawer': true }
        if (this.drawerAvailability[drawerIndex] !== true) {
          classes['builder__drawer--disabled'] = true
        }
        return classes
      },

      drawerOptionsClasses(drawerIndex) {
        let classes = { 'builder__drawer-options': true }
        let drawer = this.draweredGroupedOptionsWithSelectedValues[drawerIndex]

        if (drawer.drawerOption === null) {
          //top-level options are in a "drawer" but it can't be closed and has no header
          classes['builder__drawer-options--yes-top-level'] = true
        } else {
          classes['builder__drawer-options--no-top-level'] = true
        }

        if (drawerIndex === this.openDrawerIndex) {
          //since only one drawer can be open, they default to closed
          classes['builder__drawer-options--expanded'] = true
        }

        return classes
      },

      draweredGroupedOptionsAvailableForDrawer(drawerIndex) {
        return this.draweredGroupedOptionsWithSelectedValues[drawerIndex].options.
          reduce((acc, o) => acc + this.isOptionAvailable(o.id) ? 1 : 0, 0)
      },

      drawerHeaderClickHandler(drawerIndex) {
        if (this.openDrawerIndex === drawerIndex) {
          this.openDrawerIndex = null //all drawers closed
        } else {
          if (this.drawerAvailability[drawerIndex] === true) {
            this.openDrawerIndex = drawerIndex
          } else {
            let problemDrawerIndex = this.drawerAvailability[drawerIndex]
            alert('Please complete all '+
              (this.draweredGroupedOptionsWithSelectedValues[problemDrawerIndex].drawerOption.display_title
                 ? this.draweredGroupedOptionsWithSelectedValues[problemDrawerIndex].drawerOption.display_title
                 : this.draweredGroupedOptionsWithSelectedValues[problemDrawerIndex].drawerOption.title)+
              ' selections.')
          }
        }
      },

      isOptionAvailable(optionId) {
        //conditional options will not be visible unless the conditions are met
        let retval = false
        let option = this.product.options.find(option => option.id === optionId)
        if (option.is_conditional !== '1') {
          retval = true
        } else {
          const conditional_upon_option_id = option.conditional_upon_option_id
          let conditionalOption = this.product.options.find(option => option.id === conditional_upon_option_id)
          if (conditionalOption) {
            //conditional upon a checkbox implies the checkbox is checked
            const conditional_upon_choice_id = option.display_type === 'checkbox' ? 1 : option.conditional_upon_choice_id
            if (conditional_upon_choice_id === conditionalOption.selected_value) {
              retval = this.isOptionAvailable(conditional_upon_option_id) //support nested conditional options
            }
          }
        }
        return retval
      },

      selectOptionValue(optionId, choiceIdOrText) {
        //Nullify embroidery grouped option values
        // if the parent embroidery option is not selected
        // (in case user entered some embroidery-grouped data
        // but then changed their mind and un-checked the overall embroidery).
        this.groupedOptionsWithSelectedValues
            .filter(o => o.id == optionId)
            .forEach(o => {
              if ((o.display_type == 'embroidery' || o.is_embroidery_parent == '1') && !choiceIdOrText) {
                o.embroidery_grouped_options.forEach(eo => {
                  this.selectOptionValue(eo.id, null)
                })
              }
            })

        //use Vue.set()/Vue.delete() because Vue can't track additions/deletions
        // of object properties using plain 'ol javascript
        if (choiceIdOrText) {
          Vue.set(this.selectedOptionValues, optionId, choiceIdOrText)
        } else {
          Vue.delete(this.selectedOptionValues, optionId)
        }

        this.$nextTick(function () {
          //walk through all options and clear them out if they're not currently available
          //this is so that no "hidden" option selections remain in the URL
          this.product.options.forEach(o => {
            if ( ! this.isOptionAvailable(o.id) ) {
              Vue.delete(this.selectedOptionValues, o.id)
            }
          })
        })
      },

      selectOptionsFromQueryString(qs) {
        if (qs) {
          let validOptionIds = this.product.options.map(o => o.id)

          qs.split('&').forEach(kv => {
            let pair = kv.split('=')
            let key = decodeURIComponent(pair[0].replace(/\+/g, ' '))
            let val = decodeURIComponent(pair[1].replace(/\+/g, ' '))

            if (validOptionIds.indexOf(key) > -1) {
              this.selectOptionValue(key, val)
            }
          })
        }
      },

      submit(sendToCartVsComparisonGallery) {
        if (this.validate()) {
          this.isSubmitting = true

          let data = {
            ccm_token: customBuilderAppData.csrfToken,
            add: {
              product: {
                id: this.product.id,
                quantity: 1,
                options: this.selectedOptionValues,
              },
            },
          }

          let url = sendToCartVsComparisonGallery ? customBuilderAppData.cartAction : customBuilderAppData.comparisonGalleryAction

          $.post(url, data, (response) => {
            if (response.success) {
              window.location.href = url
            } else {
              alert("Please correct the following errors: \n\n" + response.errors.join("\n"))
              this.isSubmitting = false
            }
          }, 'json')
        }
      },

      validate() {
        let errors = []

        this.groupedOptionsWithSelectedValues.forEach(o => {
          this.validateGroupedOption(o, errors)
        }, this)

        if (errors.length) {
          alert("Please correct the following errors: \n\n" + errors.join("\n"))
          return false
        } else {
          return true
        }
      },

      validateGroupedOption(o, errors) {
        let isValid = true //be optimistic

        //embroidery grouped options are only required
        // if their parent embroidery option is checked...
        if ((o.display_type == 'embroidery' || o.is_embroidery_parent == '1') && o.selected_value) {
          o.embroidery_grouped_options.forEach(eo => {
            if (eo.is_required && !eo.selected_value && this.isOptionAvailable(eo.id)) {
              isValid = false
              errors.push((o.display_title ? o.display_title : o.title) + ' :: ' + (eo.display_title ? eo.display_title : eo.title) + ' is required')
            }
          })

        //non-embroidery-grouped (and non-embroidery) options:
        } else if (o.is_required && !o.selected_value && this.isOptionAvailable(o.id) && o.display_type !== 'drawer') {
          isValid = false
          errors.push((o.display_title ? o.display_title : o.title) + ' is required')
        }

        return isValid
      },
    },
  }
</script>



// WEBPACK FOOTER //
// App.vue?752c888c